import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPaginationParams } from '@interfaces';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';
import { ISupplierGift } from '../interfaces/ISupplier';

@Injectable({
  providedIn: 'root',
})
export class SupplierGiftService {
  constructor(private http: HttpClient) {}

  getAllSuppliersGiftBySupplier(supplierId: string, params: IPaginationParams): Observable<ApiResponse> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift`, { params: httpParams });
  }

  createSupplierGift(supplierId: string, supplierData: ISupplierGift): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift`, supplierData);
  }

  updateSupplierGift(supplierId: string, id: string, supplierData: ISupplierGift): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift/${id}`, supplierData);
  }

  deleteSupplierGift(supplierId: string, id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift/${id}`);
  }

  getGiftById(supplierId: string, id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift/${id}`);
  }

  exportSupplierGift(supplierId: string, filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/supplier/${supplierId}/supplier-gift/export`,
      filterData,
      options,
    );
  }

  getCouponsData(supplierId: string, giftId: string, params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift/${giftId}/coupons`, {
      params: httpParams,
    });
  }

  importCouponData(supplierId: string, giftId: string, data: { url: string }) {
    return this.http.post<ApiResponse>(`/v1/admin/supplier/${supplierId}/supplier-gift/${giftId}/coupons`, data);
  }

  getOrderByUserId(userId: string) {
    return this.http.get<ApiResponse>(`v1/admin/supplier/user-order/${userId}`);
  }

  exportSupplierGiftCoupons(supplierId: string, giftId: string, filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/supplier/${supplierId}/supplier-gift/${giftId}/coupons/export`,
      filterData,
      options,
    );
  }

  exportSupplierGiftOrder(userId: string, filterData: IPaginationParams) {
    let params = new HttpParams()
      .set('pageNum', filterData.pageNum.toString())
      .set('pageLimit', filterData.pageLimit.toString())
      .set('search', filterData.search ? filterData.search : '')
      .set('sortField', filterData.sortField ? filterData.sortField : '')
      .set('sortOrder', filterData.sortOrder ? filterData.sortOrder.toString() : '');
    filterData?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      params = params.set(key, value?.$regex);
    });
    const options = {
      params: params,
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.post<HttpResponse<Blob>>(`v1/admin/supplier/user-order/${userId}/export`, filterData, options);
  }
}
